import React from 'react';

// Based on https://reactjs.org/docs/error-boundaries.html
export class ErrorBoundary extends React.Component {
  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('Global error', error, errorInfo, error?.stack);

    // eslint-disable-next-line react/no-unused-state
    this.setState({ hasError: true, error, errorInfo });
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    const { hasError = false } = this.state || {};
    const { children, fallback } = this.props;

    if (hasError) {
      // You can render any custom fallback UI
      return fallback;
    }

    return children;
  }
}
